<!-- TnC Model -->
<button type="button" class="btn btn-primary" id="openTnc" [hidden]="true" data-toggle="modal" data-target="#tncModel"
  data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="tncModel" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">B2B Terms & Conditions Acceptance.</h5>
        <!-- <h5 class="modal-title" id="apiAccessTitle">{{tnc.name}}</h5> -->
        <button id="closeTnc" type="button" class="close" [hidden]="true" data-dismiss="modal">CANCEL</button>
      </div>
      <div class="modal-body">
        <div class="row p-3">
          <div class="col-12 mt-4">
            <div class="custom-control custom-checkbox float-left">
              <input type="checkbox" class="custom-control-input font13-400" id="cbAcceptTnC"
                [(ngModel)]="isTnCAccepted">
              <label class="custom-control-label lh-23" for="cbAcceptTnC">Check here to indicate that you have read and
                agree to the&nbsp;
                <a class="font14-600-link" href="{{tnc.url}}" target="_blank">NCC Terms and Conditions.</a>
              </label>
            </div>
          </div>
          <div class="col-12 mt-3 font14-400"><span class="text-muted">Effective
              From:&nbsp;</span><span>{{tnc.effectiveDate | date:'MMM d, y'}}</span></div>

          <div class="col-12 mt-5 text-center">
            <button type="button" [disabled]="!isTnCAccepted" class="btn btn-primary btn-block"
              (click)="acceptTnc()">Accept and Continue</button>
          </div>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <div class="row width-100">
          <div class="col-12">
            <button type="button" [hidden]="true" [disabled]="!isTnCAccepted" class="btn btn-primary float-right"
              (click)="acceptTnc()">Accept</button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>